export default __webpack_public_path__ + "static/media/button__thumbs-down.0156c001.svg";